import apiClient from "./client";

export const getBoards = async ({ language = "en" } = {}) => {
  const response = await apiClient.get("/boards", {
    params: { language },
  });
  return response.data;
};

export const getBoardById = async ({ id, language = "en" }) => {
  const response = await apiClient.get(`/boards/${id}`, {
    params: { language },
  });
  return response.data;
};
